export default __webpack_public_path__ + "static/media/undo.5298947c.svg";